import React from "react";
import ReactPaginate from "react-paginate";

const CustomPaginationMobile = ({data, handlePage}) => {
     
  return (
    <> 
      <div className="card-footer py-3 mobile-custom-pagination me-3">
        <nav className="d-flex justify-content-end">
        <ReactPaginate
        breakLabel="..."
        nextLabel="Next"
        onPageChange={handlePage}
        pageRangeDisplayed={4}
        pageCount={data?.pageCount}
        previousLabel="Previous"
        renderOnZeroPageCount={null}
        marginPagesDisplayed={1}
        containerClassName="pagination justify-content-center"
        pageClassName="page-item mobile-page-number"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        breakClassName="page-item mobile-page-number"
        nextLinkClassName="page-link"
        activeClassName="active"
      />
        </nav>
      </div>
    </>
  );
};
export default CustomPaginationMobile;